import React from "react";

import { Drawer } from "@mui/material";
import { SimpleHeadMui } from "components/Simple-head/SimpleHeadMui";

import { Create } from "./Create";
import { Edit } from "./Edit";

interface Props {
  dealId: number;
  formState: { id?: number } | null;
  refetchTable: () => void;
  onClose: () => void;
}

export const FeeItemManage: React.FC<Props> = ({ dealId, formState, refetchTable, onClose }) => {
  return (
    <Drawer
      sx={{
        ".MuiPaper-root": {
          display: "flex",
          flexDirection: "column",
          borderTopRightRadius: "25px",
          borderBottomRightRadius: "25px",
          maxWidth: 520,
          minWidth: 520,
          width: 520,
          bgcolor: "white",
          overflow: "hidden"
        }
      }}
      open={Boolean(formState)}
      onClose={onClose}
    >
      <SimpleHeadMui onIconClick={onClose}>Add Management Fee</SimpleHeadMui>
      {formState && !formState.id && <Create dealId={dealId} refetchTable={refetchTable} onClose={onClose} />}
      {formState && formState.id && (
        <Edit feeId={formState.id} dealId={dealId} refetchTable={refetchTable} onClose={onClose} />
      )}
    </Drawer>
  );
};
